module.exports = __webpack_public_path__ + "img/food4.436e57bc.png";